import type { IconSvgObject } from './types';

const BluetoothOffIcon: IconSvgObject = [
  ["path", { d: "M7 17L12.0014 11.9986V21L17 17M12.0014 7.00141V3L17 6.99997L14.5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BluetoothOffIcon;
